<template>
  <div id="home">
    <PortalSidebar/>
    <div class="page-container">
      <PortalPageHeader page-title="Not Found"/>
      <main class="main-content"></main>
    </div>
  </div>
</template>

<script>
import PortalSidebar from "@/components/PortalSidebar.vue";
import PortalPageHeader from "@/components/PortalPageHeader.vue";

export default {
  name: "NotFound",
  components: {
    PortalSidebar,
    PortalPageHeader
  }
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue